import { EpaperPublicationType, Issue } from '@news-mono/web-common'
import React from 'react'
import { useSection } from '../../../../__helpers'
import { EpaperCollection } from '../EpaperCollection'
import { StyledLatestEditionContainer } from '../EpaperCollection.styled'
import { StyledReadersAlsoLoveHeading } from './ReadersAlsoLove.styled'

export interface ReadersAlsoLoveProps {
    allEditions: Issue[]
}

export const ReadersAlsoLove: React.FC<ReadersAlsoLoveProps> = (props) => {
    const section = useSection()
    return (
        <React.Fragment>
            <StyledReadersAlsoLoveHeading>
                Readers Also Love
            </StyledReadersAlsoLoveHeading>
            <StyledLatestEditionContainer>
                <EpaperCollection
                    issues={props.allEditions}
                    sectionToExclude={section as EpaperPublicationType}
                />
            </StyledLatestEditionContainer>
        </React.Fragment>
    )
}
